<template>
    <v-card outlined>
        <v-card-title>
            登録済み印影
        </v-card-title>
        <v-simple-table>
            <template v-slot:default>
                <tbody>
                    <tr
                        v-for="(item,index) in seals"
                        :key="index"
                        v-on:click="selectRegisteredSeal(item.image_data)"
                    >
                        <td>{{ item.imprint_name }}</td>
                        <td>
                            <v-img
                                :src="item.image_data"
                                max-height="50"
                                max-width="50"
                                width="50"
                                height="50"
                                :contain="true"
                            >
                            </v-img>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-card>
</template>

<script>
    export default {
        data: function () {
            return {
                seals: []
            }
        },
        created: function () {
            axios.get('/documents/workflow/get-electronic-imprints')
            .then(response => {
                this.seals = Object.assign({}, response.data.imprints)
            })
            .catch(function (response) {
                console.log(response)
            })
        },
        methods: {
            selectRegisteredSeal: function (sealData) {
                this.$emit('selectRegisteredSeal', sealData)
            }
        }
    }
</script>

<style>

</style>